
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commanders/[...slug]",
      function () {
        return require("private-next-pages/commanders/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commanders/[...slug]"])
      });
    }
  